import { render, staticRenderFns } from "./page-new-user.vue?vue&type=template&id=33ef1ff2&scoped=true&"
import script from "./page-new-user.vue?vue&type=script&lang=js&"
export * from "./page-new-user.vue?vue&type=script&lang=js&"
import style0 from "./page-new-user.vue?vue&type=style&index=0&id=33ef1ff2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef1ff2",
  null
  
)

export default component.exports